export enum DetailsType {
    BOOKINGS,
    USERS,
    RULES,
    GROUPS,
    ALERTS,
}